import { Resource } from '@user1st/api-client';

export const ResourceKeyPath: Partial<Record<Resource, string>> = {
  ENTERPRISE_LANDING_PAGE: 'lp/enterprise',
  EAA_LANDING_PAGE: 'lp/eaa',
  HOME_LANDING_PAGE: 'lp/home',
  PRICING_BLOCK: 'pricing',
  WHITEPAPERS: 'whitepapers',
  ALTERNATIVES: 'alternatives',
  ACCESSIBILITY_CHECKER: 'accessibility-checker',
};
